var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "level" }, [
      _c(
        "div",
        { staticClass: "level-left" },
        [
          _c("hospitals-filter", { staticClass: "level-item" }),
          _c("groups-filter", { staticClass: "level-item" }),
          _c("users-filter", { staticClass: "level-item" }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "level-right" },
        [_c("date-filter", { staticClass: "level-item" })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }